import { motion } from 'framer-motion';

import { faq } from 'constants/home';
import { FaqCategory } from 'models/Faq';

import { FaqSwitcherContainer } from './styles';

interface ComponentProps {
	faqCategory: FaqCategory;
	onChange: (category: FaqCategory) => void;
}

function FaqSwitcher(props: ComponentProps) {
	return (
		<FaqSwitcherContainer className="faq-switcher">
			{Object.values(faq).map((faq) => (
				<motion.div
					key={faq.category}
					className="item"
					onClick={() => props.onChange(faq.category)}
				>
					<span>{faq.label}</span>

					{props.faqCategory === faq.category && (
						<motion.div
							className="underline"
							layoutId="underline"
						/>
					)}
				</motion.div>
			))}
		</FaqSwitcherContainer>
	);
}

export default FaqSwitcher;
